/*
    Made by : Samuel
    Date : 21
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { ReactNode } from "react";
import styles from "./Section.module.css";

// ----------------------------------------------------------------------------- //
// PROPS //

interface SectionProps {
    id: string;
    title: string;
    children: ReactNode;
}

// ----------------------------------------------------------------------------- //
// COMPONENT //

function Section({ id, title, children }: SectionProps) {
    return (
        <section id={id} className={`${styles.section} mb-5 py-5`}>
            <div className="container">
                <h2 className="mb-4 text-center">{title}</h2>
                {children}
            </div>
        </section>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default Section;

// ----------------------------------------------------------------------------- //
